import React, { useEffect, useState } from 'react';
import RenderSections from './RenderSections';
import Heading from '@hubins/components/Heading';
import SectionForm from './SectionForm';
import { __ } from 'localisation';

const Section = ({
  params,
  type,
  form,
  profileUuid,
  portfolioUuid,
  uuid,
  role,
  setSubmittedDueDiligence,
  submittedDueDiligence,
  isExecuted,
  hasBeenApproved,
  setInvalid,
  endDate,
  onLoad
}) => {
  const [forms, setForms] = useState([]);

  useEffect(() => {
    if (form) {
      const newForms = form.split(',');
      setForms(newForms);
    }
  }, [form]);

  const SectionContent = RenderSections[type] ? RenderSections[type](params, role, isExecuted, setInvalid, endDate, onLoad) : <Heading size="2">No content found for section with type {type}</Heading>;

  return (
    <>
      {SectionContent}
      <div id="due_dilligence_checks" data-page-navigation-anchor={__('due_dilligence_checks')}>
        <Heading size="3" className="s-top-xl">
          {__('due_dilligence_checks')}
        </Heading>
        {forms && (
          forms.map((formKey, index) => (
            <SectionForm
              key={index}
              form={formKey}
              profileUuid={profileUuid}
              portfolioUuid={portfolioUuid}
              uuid={uuid}
              role={role}
              setSubmittedDueDiligence={setSubmittedDueDiligence}
              submittedDueDiligence={submittedDueDiligence}
              isExecuted={isExecuted}
              hasBeenApproved={hasBeenApproved}
            />
          ))
        )}
      </div>
    </>
  );

};

export default Section;
